/*!
 * slxControls v1.0.8 (http://selerix.com)
 * Copyright 2017 Selerix Systems, Inc. All Rights Reserved.
 * This is unpublished proprietary source code of Selerix, Inc. The
 * copyright notice above does not evidence any actual or intended
 * publication of such source code.
 *
 * Dependencies: jQuery v1.10+, Bootstrap v3.2+, polyfills.js
 */
(function () {
	'use strict';
	var x = window.SlxControl;

    /*
	 * slx.worker
	 * Dependencies: slx.core, slx.worker.poller
	 */
    x.slx.worker = function worker(settings) {
        var that = this;
        that.worker = null;
        var el = x({});

        // start polling
        that.start = function (settings) {
            if (that.worker === null) { return false; }
            settings.action = 'start';
            that.worker.postMessage(settings);
            el.triggerHandler('start');
            return true;
        };

        // stop polling
        that.stop = function () {
            if (that.worker === null) { return false; }
            that.worker.postMessage({ action: 'stop' });
            el.triggerHandler('stop');
            return true;
        };

        // event attaching
        that.off = function (type) { el.off(type); return that; };
        that.on = function (type, listener) { el.on(type, listener); return that; };
        that.addEventListener = function (type, listener) { that.off(type).on(type, listener); return that; };
        that.removeEventListener = function (type) { that.off(type); return that; };

        // initialization
        (function () {
            that.worker = new Worker(settings.source || x.slx.scriptpath + 'slx.worker.poller.js?v=' + (x.slx.version || 0));
            that.worker.onerror = typeof (settings.onerror) === 'function' ? settings.onerror : function (err) {
                that.stop();
                el.trigger(x.Event('error', err));
            };
            that.worker.addEventListener('message', function (e) {
                el.triggerHandler('message', e.data);
            }, false);
        })();

        // localized error object
        var Error = function (number, message, description) {
            var e = new window.Error(number, message);
            this.status = number || 0;
            this.statusText = message;
            this.response = description;
            this.responseText = description !== null && description !== void 0 ? description.toString() : '';
            this.stack = e.stack;
            this.name = e.name;
            this.namespace = 'slx.worker';
        };

        // events
        (function () {
            that.off('error.slx.worker').on('error.slx.worker', function (err) {
                if (typeof (settings.onerror) === 'function') { settings.onerror(err); }
            });
            that.off('start.slx.worker').on('start.slx.worker', function (e) {
                if (typeof (settings.onstart) === 'function') { settings.onstart(e); }
            });
            that.off('message.slx.worker').on('message.slx.worker', function (e, data) {
                if (typeof (settings.onmessage) === 'function') {
                    var resp;
                    try { resp = JSON.parse(data); }
                    catch (ex) { resp = data; }

                    if (resp.error !== void 0) {
                        el.trigger(x.Event('error', new Error(resp.error, resp.message, resp.description)));
                        that.stop();
                        return;
                    }

                    settings.onmessage(resp);
                }
            });
            that.off('stop.slx.worker').on('stop.slx.worker', function (e) {
                if (typeof (settings.onstop) === 'function') { settings.onstop(e); }
            });
        })();
    };

    // jQuery extenders
	x.extend({ slxWorker: function (settings) { return new x.slx.worker(settings); } });

	return x;
})();